import React, { useEffect, useRef } from "react";

import Chart from "chart.js/auto";
import zoomPlugin from "chartjs-plugin-zoom";
Chart.register(zoomPlugin);

const ZoomableBarChart = ({ value, legend }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");
    const dataset = value?.values?.map((e, i) => {
      return {
        label: e?.name,
        backgroundColor: i % 2 === 0 ? "#CDE9F3" : "#F3D7CD",
        borderRadius: 4,
        borderSkipped: false,
        hoverBackgroundColor: i % 2 === 0 ? "#CDE9F3" : "#F3D7CD",
        data: e?.data,
      };
    });
    console.log(dataset);
    // Sample data
    const data = {
      labels: value?.labels,
      datasets: dataset,
    };

    const options = {
      //   responsive: true,
      // maintainAspectRatio: false,

      scales: {
        x: {
          type: "category",
          min: 0,
          max: value?.labels >= 7 ? 15 : 31,
          grid: {
            display: false,
          },

          border: {
            display: false,
          },
        },

        y: {
          grid: {
            display: false,
          },
          border: {
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: legend,
          position: "bottom",
          labels: {
            borderRadius: 0,
            boxWidth: 16,
            boxHeight: 16,
            font: {
              family: "Saysettha OT",
            },
          },
        },
        zoom: false
        // zoom: {
        //   pan: {
        //     enabled: true,
        //     mode: "x",
        //     threshold: 1,
        //   },
        // },
      },
    };

    const config = {
      type: "bar",
      data: data,
      options: options,
    };

    const chart = new Chart(ctx, config);

    return () => {
      chart.destroy();
    };
  }, [value]);

  return <canvas id="myChart" ref={chartRef} />;
};

export default ZoomableBarChart;
